


























































import { computed, defineComponent, onMounted, ref } from '@vue/composition-api';
import Header from '@/components/header/index.vue';
import DrainageSheet from '@/components/drainage-sheet/index.vue';
import ComplianceFooter from '@/components/compliance-footer/index.vue';
import { Swipe, SwipeItem } from '@upc/vant';
import { getRealPx, gotoCollege } from '@/utils/tools';
import urlExt from '@/kits/url';
import { isInHomeWork, isInKd } from '@/kits/system';

export default defineComponent({
  name: 'other-ad2',
  components: {
    Header,
    DrainageSheet,
    ComplianceFooter,
    Swipe,
    SwipeItem
  },
  props: {
    type: {
      type: String,
      default: ''
    }
  },
  setup(props, { root }) {
    const goback = () => {
      root.hybrid('exit');
    };

    const from = urlExt.getQuery('from');
    const showPop = ref(false);

    const swipeActive = ref(0);
    const swipeRef = ref();

    const swipeChange = (index: number) => {
      swipeActive.value = index;
    };

    const swipeTo = (index: number) => {
      swipeRef.value.swipeTo(index);
    };

    const handleClick = () => {
      root.zstrack({
        name: from === 'kd' ? 'JC6_014' : 'JC7_014',
        locationId: `other${props.type ? `_${props.type}` : ''}_ad2`
      });
      if (isInHomeWork || isInKd) {
        showPop.value = true;
      } else {
        gotoCollege();
      }
    };

    const titleColor = ref('#fff');
    const headerBackground = ref('transparent');

    const initScroll = () => {
      const scrollBox = document.querySelector('.content') as HTMLElement;

      const handleScroll = () => {
        // 获取当前滚动的垂直距离
        const scrollTop = scrollBox.scrollTop;
        if (scrollTop > 0) {
          headerBackground.value = '#fff';
        } else {
          headerBackground.value = 'transparent';
        }
      };

      scrollBox?.addEventListener('scroll', handleScroll);
    };

    const arrowStyle = computed(() => {
      const index = swipeActive.value;
      // space-between 布局：第一个 item 左对齐，最后一个右对齐
      // center[i] = padding + itemWidth/2 + i * (itemWidth + gap)
      // gap = (contentWidth - 4 * itemWidth) / 3
      // 等价于 calc：offset + i * (itemW + (100% - totalFixed) / 3)
      const offset = getRealPx(44 + 59); // padding(44) + half item width(59)
      const itemW = getRealPx(118);
      const totalFixed = getRealPx(44 * 2 + 4 * 118); // 两侧 padding + 4个 item 宽
      const left = `calc(${offset}px + ${index} * (${itemW}px + (100% - ${totalFixed}px) / 3))`;

      return {
        left,
        transform: 'translateX(-50%)'
      };
    });

    const handleLoad = (event: any) => {
      event.target.style.opacity = 1;
    };

    onMounted(() => {
      initScroll();
      root.zstrack({
        name: from === 'kd' ? 'JC6_008' : 'JC7_008',
        contentType: `other${props.type ? `_${props.type}` : ''}_ad2`
      });
    });

    return {
      goback,
      showPop,
      gotoCollege,
      titleColor,
      headerBackground,
      swipeActive,
      swipeRef,
      swipeChange,
      swipeTo,
      handleLoad,
      handleClick,
      arrowStyle
    };
  }
});
